<template>
    <v-dialog v-model="show" width="1200">
        <v-card v-if="packageItem !== null" style="min-height: 600px">
            <v-card-title primary-title class="headline grey lighten-2 pa-0">
                <v-layout row justify-space-between align-center>
                    <div class="ml-3">{{$t('package') | capitalize}}: {{packageItem ? packageItem.name : ''}}</div>
                    <v-btn flat icon @click="close">
                        <v-icon>close</v-icon>
                    </v-btn>
                </v-layout>
            </v-card-title>
            <v-card-text>
                <v-layout row justify-space-between class="mb-3">
                    <div>
                        <div><b>{{$t('unitPrice') | capitalize}} / {{unit}}</b></div>
                        <table class="unit-price unit-price-tooltip">
                            <tr v-for="item in packageItem.config.unit_price" :key="item.start">
                                <td>
                                    <div>{{item.start | formatNumber}}</div>
                                </td>
                                <td>
                                    <div class="font-weight-bold">{{item.price}}</div>
                                </td>
                                <td>
                                    <div class="font-weight-bold">{{item.unit}}</div>
                                </td>
                            </tr>
                        </table>
                    </div>
                    <div><b>{{$t('total') | capitalize}}: {{totalPrice | formatNumber}}</b></div>
                    <div class="ml-5">
                        <v-btn-toggle v-model="isChartView" mandatory>
                            <v-btn flat :value="true">
                                Chart
                            </v-btn>
                            <v-btn flat :value="false">
                                Table
                            </v-btn>
                        </v-btn-toggle>
                    </div>
                </v-layout>
                <div>
                    <BarChart ref="BarChart" v-if="isChartView"></BarChart>
                    <div style="overflow: auto; max-height: 700px" v-else>
                        <SimpleDataTable :items="data" :headers="headers"></SimpleDataTable>
                    </div>
                </div>
            </v-card-text>
        </v-card>
    </v-dialog>
</template>

<script>
import VueChart from 'vue-chartjs'
import SaleService from '@/services/sale.service'
import ApiService from '@/services/apis.service'
import ProjectService from '@/services/project.service'
import moment from 'moment'
import SimpleDataTable from '@/modules/fptai/components/SimpleDataTable'

export default {
    name: 'PostPaidPackageDetails',
    components: { BarChart: VueChart.Bar, SimpleDataTable },
    data () {
        return {
            show: false,
            packageItem: null,
            data: [],
            labels: [],
            isChartView: false
        }
    },
    computed: {
        headers () {
            const headers = [
                {
                    text: this.$t('time'),
                    value: (item, index) => this.labels[index],
                    sortable: false
                },
                {
                    text: this.$t('usage') + ' (' + this.unit + ')',
                    value: item => this.$filters.formatNumber(item),
                    sortable: false
                },
                {
                    text: this.$t('price') + ' (vnd)',
                    value: item => this.$filters.formatNumber(this.calculatePrice(item)),
                    sortable: false
                }
            ]
            for (let item of headers) {
                item.text = this.$filters.capitalize(item.text)
            }
            return headers
        },
        totalPrice () {
            let sum = 0
            for (let item of this.data) {
                sum += this.calculatePrice(item)
            }
            return sum
        },
        unit () {
            return this.$t(this.packageItem ? ApiService.getApiUnit(this.packageItem.project_api.api_code) : '')
        }
    },
    methods: {
        open (packageItem) {
            this.show = true
            this.packageItem = packageItem
            ProjectService.getPostPaidPackageMonthlyUsage(packageItem).then(
                result => {
                    this.data = result.data.data
                    let series = result.data.series
                    series.pop()
                    this.labels = series.map(item => moment(item).format('YYYY-MM'))
                    this.$nextTick(() => this.drawChart())
                }
            )
        },
        close () {
            this.show = false
        },
        drawChart () {
            if (this.$refs.BarChart) {
                let price = []
                for (let i = 0; i < this.data.length; i++) {
                    price.push(this.calculatePrice(this.data[i]))
                }
                this.$refs.BarChart.renderChart({
                    labels: this.labels,
                    datasets: [{
                        type: 'line',
                        label: this.$filters.capitalize(this.$t('price')) + ' (vnd)',
                        backgroundColor: '#FF80AB',
                        borderColor: '#FF80AB',
                        borderWidth: 3,
                        data: price,
                        yAxisID: 'y-axis-2',
                        fill: false
                    }, {
                        label: this.$filters.capitalize(this.$t('usage')) + ' (' + this.unit + ')',
                        backgroundColor: '#90CAF9',
                        borderColor: '#90CAF9',
                        borderWidth: 1,
                        data: this.data,
                        yAxisID: 'y-axis-1',
                        fill: false
                    }]
                }, {
                    responsive: true,
                    maintainAspectRatio: false,
                    title: {
                        display: false
                    },
                    scales: {
                        xAxes: [{
                            barPercentage: 0.4
                        }],
                        yAxes: [{
                            type: 'linear',
                            display: true,
                            position: 'left',
                            id: 'y-axis-1'
                        }, {
                            type: 'linear',
                            display: true,
                            position: 'right',
                            id: 'y-axis-2',
                            gridLines: {
                                drawOnChartArea: false
                            }
                        }]
                    }
                })
            }
        },
        calculatePrice (amount) {
            return SaleService.calculatePrice(amount, this.packageItem.config.unit_price)
        }
    },
    watch: {
        isChartView (isChartView) {
            if (isChartView) {
                this.$nextTick(() => this.drawChart())
            }
        }
    }
}
</script>

<style scoped lang="scss">
    table.pricing {
        border-collapse: collapse;

        th, td {
            padding: 5px;
        }
    }

    table.unit-price {
        td {
            padding-right: 15px;
        }
    }
</style>
